import React, { useState, useEffect, useContext } from 'react'
import { Input, Select, Image, Spin, Empty, Upload, Button, message } from 'antd'
import Pager from '../../../../../../../../../pager'
import { SearchOutlined } from '@ant-design/icons'
import { beforePicUpload } from '../../../../../../../../utils'
import { TableContext } from '../../../../../../../../'
// import { getImgZoneList } from 'SERVICES/activity'
// import * as AppConst from 'CONSTANTS/AppConst'

import './index.less'

const { Option } = Select

const ImgList = (props) => {
  const { imgData, selectedKeys, onChange = () => {} } = props
  const { getImgZoneList, uploadImgZone } = useContext(TableContext)
  const normalType = imgData.imgExtension.split(',').map((item) => item.toLocaleUpperCase())
  const [loading, setLoading] = useState(false)
  const [listData, setListData] = useState([])
  const [selectId, setSelectId] = useState()
  const [uploadImgName, setUploadImgName] = useState('')
  const [total, setTotal] = useState(0)
  const [params, setParams] = useState({
    imgType: normalType,
    imgName: '',
    orderEnum: 'DESC',
    orderColumn: 'createDate',
    pageIndex: 1,
    pageSize: 20,
    cateId: selectedKeys[0],
  })

  const getListData = (cateId) => {
    setLoading(true)
    setListData([])
    const data: any = { ...params, cateId }
    if (params.orderEnum.indexOf(',') !== -1) {
      data.orderColumn = params.orderEnum.split(',')[0]
      data.orderEnum = params.orderEnum.split(',')[1]
    }
    data.imgType = data.imgType.join(',')
    getImgZoneList(data).then((res) => {
      setLoading(false)
      if (res.success) {
        setTotal(res.data.totalCount)
        setListData(res.data.items || [])
      }
    })
  }

  const handleFileChange = (e) => {
    const response = e.file.response
    if (response && response.success) {
      message.success('上传成功')
      setTimeout(() => {
        getListData(selectedKeys[0])
      }, 1500)
    }
  }

  const beforeUpload = (file) => {
    setUploadImgName(file.name)
    return beforePicUpload(file, {
      imgWidth: imgData.width,
      imgHeight: imgData.height,
      imgExtension: imgData.imgExtension.toLocaleLowerCase(),
      imgSize: imgData.size,
    })
  }

  useEffect(() => {
    if (params) {
      getListData(selectedKeys[0])
    }
  }, [params, selectedKeys])

  const renderSearch = () => {
    const onSearchVal = () => {
      setParams({ ...params })
    }
    return (
      <div className="img-zone-search">
        <Input
          placeholder="请输入查询关键词"
          style={{ width: 225 }}
          onChange={(e) => {
            params.imgName = e.target.value
          }}
          onKeyDown={(e) => {
            if (e.keyCode == 13) {
              setParams({ ...params })
            }
          }}
          suffix={
            <SearchOutlined
              style={{ color: 'rgba(0, 0, 0, 0.25)', fontSize: 20, cursor: 'pointer' }}
              onClick={onSearchVal}
            />
          }
        />
        <Select
          defaultValue="createDate,DESC"
          style={{ width: 194, margin: '0 12px' }}
          onChange={(e) => {
            params.orderEnum = e
            setParams({ ...params })
          }}
        >
          <Option value="createDate,DESC">最新上传在前</Option>
          <Option value="createDate,ASC">最新上传在后</Option>
          <Option value="imgName,ASC">按图片名升序</Option>
          <Option value="imgName,DESC">按图片名降序</Option>
        </Select>
        <Select
          defaultValue={normalType}
          style={{ width: 194 }}
          value={params.imgType}
          mode="multiple"
          onChange={(e) => {
            if (e && e.length) {
              params.imgType = e
              setParams({ ...params })
            }
          }}
        >
          {imgData.imgExtension.split(',').map((item) => (
            <Option value={item} key={item}>
              {item.toLocaleUpperCase()}
            </Option>
          ))}
        </Select>
        <div style={{ float: 'right' }}>
          <Upload
            action={uploadImgZone}
            name="imgFile"
            withCredentials
            accept=".png,.jpg,.jpeg"
            showUploadList={false}
            beforeUpload={(file) => beforeUpload(file)}
            data={{ cateId: selectedKeys[0], imgName: uploadImgName }}
            onChange={handleFileChange}
          >
            <Button type="primary" ghost style={{ marginRight: 32, borderRadius: 35 }}>
              本地上传
            </Button>
          </Upload>
        </div>
      </div>
    )
  }

  const onChangePager = (e, pageSize) => {
    params.pageIndex = e
    if (pageSize !== params.pageSize) {
      params.pageIndex = 1
      params.pageSize = pageSize
    }
    setParams({ ...params })
  }

  const renderImg = (item) => {
    const onSelect = () => {
      setSelectId(item.imgUrl)
      onChange(item.imgUrl)
    }
    return (
      <div className="img-container" onClick={onSelect}>
        <Image
          width={90}
          src={`//img10.360buyimg.com/applylogo/${item.imgUrl}`}
          preview={false}
          className={item.imgUrl === selectId ? 'selected' : ''}
        />
        <div className="img-title" title={item.imgName}>
          {item.imgName}
        </div>
      </div>
    )
  }

  return (
    <Spin spinning={loading}>
      <div className="img-list-container">
        {renderSearch()}
        {!!listData.length ? (
          <div className="cotainer">{listData.map((item, index) => renderImg(item))}</div>
        ) : (
          <div style={{ height: 250, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          </div>
        )}

        <div style={{ textAlign: 'right', marginRight: 32 }}>
          <Pager
            current={params.pageIndex}
            defaultPageSize={params.pageSize}
            pageSizeOptions={[10, 20, 50]}
            total={total}
            onChange={onChangePager}
            showTotal={(total) => `共 ${total} 条数据`}
          />
        </div>
      </div>
    </Spin>
  )
}

export default ImgList
